import { notify } from "@general-backoffice/core";
import Header from "@general-backoffice/core/lib/pages/auth/components/Header";
import { usersEndpoints } from "@investhinks/api-client";
import React, { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import getErrorMessage from "../../../utils/getErrorMessage";

const ConfirmUserRemoval: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [confirmed, setConfirmed] = useState(false);

  const token = searchParams.get("token");

  const confirmRemoval = () => {
    if (!token) return;
    usersEndpoints
      .confirmRemoval(token)
      .then(({ data }) => {
        notify.success(data.ok ? "Account removed" : "Account removed");
        setConfirmed(true);
      })
      .catch((e: unknown) => {
        notify.error(getErrorMessage(e, "Error"));
      });
  };

  if (!token) return <Navigate to="/" replace />;
  return (
    <React.Fragment>
      <Header title="Confirm account removal" lead="Once removed you won't be able to recover it." />
      <Container className="mt--7 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardBody className="px-lg-5 py-lg-5 flex-center">
                {!confirmed ? (
                  <Button color="danger" onClick={confirmRemoval}>
                    Confirm Removal
                  </Button>
                ) : (
                  <p>Your account has been removed successfully</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ConfirmUserRemoval;
